import VmpMicInvited from './src/main';

/* istanbul ignore next */
VmpMicInvited.install = function (Vue) {
  Vue.component(VmpMicInvited.name, VmpMicInvited);
};

export default VmpMicInvited;
